import { createInfiniteQuery } from 'react-query-kit';
import { keepPreviousData } from '@tanstack/react-query';

import type { QuizsetSearchReq } from '@/api/gen/_model/quizsetSearchReq';
import type { SearchResponseListSearchQuizsetRes } from '@/api/gen/_model/searchResponseListSearchQuizsetRes';
import { searchMyQuizsets } from '@/api/gen/quiz-user/quiz-user.gen';

export const useFetchMyQuizes = createInfiniteQuery<
  SearchResponseListSearchQuizsetRes,
  Omit<QuizsetSearchReq, 'page'>
>({
  queryKey: ['quizsets/search'],
  fetcher: async (variables, pageParam) => {
    return searchMyQuizsets({
      ...variables,
      page: pageParam.pageParam,
    });
  },
  getNextPageParam: lastPage => {
    if (!lastPage?.currentPage || !lastPage?.totalPages) {
      return undefined;
    }

    return lastPage.currentPage < lastPage.totalPages
      ? lastPage.currentPage + 1
      : undefined;
  },
  initialPageParam: 1,
  placeholderData: keepPreviousData,
});

/**
 * 내 퀴즈 목록의 캐시 키.
 *
 * 퀴즈 목록을 stale 로 만드는 write 가 이 모듈 밖에도 있어(모음이 원본 퀴즈를 공개로
 * 전환한다) 리터럴 대신 이 키를 내보낸다.
 *
 * ⚠️ `useFetchUserQuizes`(프로필)가 같은 키를 공유해 함께 무효화된다. 공개 전환은 그 목록에도
 *    반영돼야 하므로 의도한 범위다. 자료실은 혼합 검색(`libraryKeys`)으로 떠났으므로 이 키에
 *    걸리지 않는다 — 자료실까지 갱신해야 하는 write 는 `libraryKeys.all` 도 함께 무효화한다.
 */
export const myQuizListKey = useFetchMyQuizes.getKey();
